<template>
  <div>
    <base-dialog :show="!!error" title="An error occurred" @close="handleError">
      <p>{{ error }}</p>
    </base-dialog>
    <base-dialog :show="isLoading" title="Authenticating..." fixed>
      <base-spinner></base-spinner>
    </base-dialog>
    <base-card>

      <div class="logo-field">
        <router-link :to="homeurl()"><main-logo /></router-link>
      </div>
      <div class="login-title">{{ siteName }} LOGIN</div>  
      <form @submit.prevent="submitForm2">
        <fieldset>
          <legend>로그인</legend>
          <div class="login_set">

            <dl id="login-field" class="input_list">

              <dt class="display_none" >
                <label for="mb_id">이메일 입력</label>
              </dt>
              <dd class="dd_mb_id">
                <input type="email" name="email" v-model.trim="email"  placeholder="이메일 입력" autocomplete="off">
              </dd>

              <dt class="display_none" >
                <label for="mb_password">비밀번호 입력</label>
              </dt>
              <dd class="dd_mb_pw">
                <input type="password"  name="password"  v-model.trim="password" placeholder="비밀번호 입력" autocomplete="off">
              </dd>

            </dl>

            <div class="acc">
              <div class="login_state">
                <input id="auto_login" type="checkbox" class="blind" name="auto_login" value="1">
                <label id="auto-login" for="auto_login" class="">
                  <span class="ic"></span>로그인 상태 유지
                </label>
              </div>

              <ul>
                <!-- <li>
                  <a href="" onclick="javascript:window.resizeTo(700,600);">아이디찾기</a>
                  <span class="bar"></span>
                </li> -->
                <li>
                  <router-link to="/auth/reset_pw">비밀번호 재설정</router-link>
                  <span class="bar"></span>
                </li>
                <li>
                  <router-link :to="goRegister()">
                    <strong>간편회원가입</strong>
                  </router-link>
                </li>
              </ul>
            </div>
            <p v-if="!formIsValid" class="alert-valid">
                이메일, 비밀번호를 입력해 주세요 (최소 6글자 이상입니다.).
            </p>
            
            <base-button mode="red">{{ submitButtonCaption }}</base-button>
            <button class="forKakao" @click="kakaoLogin">
              <div class="icon"><img src="@/assets/imgs/kakao_icon.png" height="20"></div> 카카오 로그인
            </button>
          </div>
        </fieldset>
      </form>
      <div class="footer">Copyright (c){{ siteName }}. All Rights Reserved.</div>
    </base-card>
  </div>
</template>

<script>
//import * as auth from '@/services/auth_service';
//import axios from 'axios'
export default {
  props:{
    prevroute:{},path:{},
    isMobile:{default:false}
  },
  data() {
    return {
      email: "",
      password: "",
      formIsValid: true,
      mode: "login",
      isLoading: false,
      error: null,
      logintype:'web',
      nickname:'',
      temp_password:'',
      profile_url:''
    };
  },
  computed: {
    siteName(){
        return this.$store.state.siteName;
    },
    submitButtonCaption() {
      if (this.mode === "login") {
        return "Login";
      } else {
        return "Signup";
      }
    },
    switchModeButtonCaption() {
      if (this.mode === "login") {
        return "가입하기";
      } else {
        return "Login instead";
      }
    },
  },
  methods: {
     goRegister(){
      if(this.isMobile)
      {
        return '/m/register';
      }else{
        return '/auth/register';
      }
    },
    kakaoLogin() {
        // console.log(window.Kakao);
      window.Kakao.Auth.login({
      scope : 'account_email, profile',
      success: this.GetMe,
      });
    },
    GetMe(authObj){
      console.log(authObj);
      window.Kakao.API.request({
        url:'/v2/user/me',
        success : res => {
          const kakao_account = res.kakao_account;       
          this.nickname = kakao_account.profile.nickname;
          this.profile_url = kakao_account.profile.profile_image_url;
          this.email = kakao_account.email;
          this.logintype = 'kakao';  
          this.temp_password = authObj.access_token;
          //https://daily-life-of-bsh.tistory.com/206 참조    
          console.log(kakao_account);      
          this.submitForm2();   
          console.log('카카오 인증 액세스 토큰 존재합니다.',window.Kakao.Auth.getAccessToken());         
        }
      });
    },
    async submitForm() {
      this.formIsValid = true;
      if (
        this.email === "" ||
        !this.email.includes("@") ||
        this.password.length < 6
      ) {
        this.formIsValid = false;
        return;
      }

      this.isLoading = true;

      const actionPayload = {
        email: this.email,
        password: this.password,        

      }

      try {
        if (this.mode === "login") {
          await this.$store.dispatch("login", actionPayload);
        } else {
          await this.$store.dispatch("signup", actionPayload);
        }
        const redirectUrl = "/" + (this.$route.query.redirect || "coaches");
        this.$router.replace(redirectUrl);
      } catch (err) {
        this.error = err.message || "Failed to authenticate, try later.";
      }

      this.isLoading = false;
    },
    async submitForm2() {
      this.formIsValid = true;
      if (
        (this.email === "" ||
        !this.email.includes("@") ||
        this.password.length < 6) && this.logintype==='web'
      ) {
        this.formIsValid = false;
        return;
      }
      this.isLoading = true;
      const actionPayload = {
        email: this.email,
        password: this.password,
        logintype:this.logintype,
        nickname: this.nickname,
        temp_password:this.temp_password,
        profile_url:this.profile_url,
        userAgent:navigator.userAgent.toLowerCase(),
      }
      //alert(this.logintype);
      try {
        //const response = await auth.login(actionPayload);
        const response = await this.$store.dispatch("login", actionPayload);
        console.log(response);
        // if(this.$route.params.prevroute)
        // {
        //   this.$router.push({ name: this.$route.params.prevroute});
         if(this.prevroute)
        {
          // this.$router.push({ name: this.prevroute});
          this.$router.push({ path: this.path});          
          //만약 팝업으로 로그인처리 할경우는 팝업은 닫고 부모경로에 주소를 바꿔줘야하는데 아래 코드 참고
          //<a href="" target="_self" onclick="window.opener.parent.location.href = '주소';window.close();">
        }else{
          if(this.isMobile)
          {
            let routename = this.$store.state.menu.activeMobileMenu;
            this.$router.push({name:routename});
          }else{
            this.$router.go(-1);
          }
          
          //this.$router.replace("/");
        }       
        
        this.$flashMessage.show({
          type: "info",
          title: response.message,
          message: response.message,
        });
      } catch (error) {
        console.log(error.response);
        switch (error.response.status) {
          case 422:
            this.$flashMessage.show({
              type: "error",
              title: "유효하지 않은 데이터 입력입니다.",
              message: "유효하지 않은 데이터 입력입니다.",
            });
            break;
          case 401:
            this.$flashMessage.show({
              type: "error",
              title: error.response.data.message,
              message: error.response.data.message,
            });
            break;
          case 500:
            this.$flashMessage.show({
              type: "error",
              title: error.response.data.message,
              message: error.response.data.message,
            });
            break;
          default:
            this.$flashMessage.show({
              type: "error",
              title: "특정 문제가 생겨 정상 등록이 되지 않았습니다!",
              message: "특정 문제가 생겨 정상 등록이 되지 않았습니다!",
            });
            break;
        }
      }
      this.logintype = 'web';
      this.isLoading = false;
      window.Kakao.Auth.logout(()=>{
        console.log('로그아웃시킵니다.',window.Kakao.Auth.getAccessToken());
      });
    },
    switchAuthMode() {
      if (this.mode === "login") {
        this.mode = "signup";
      } else {
        this.mode = "login";
      }
    },
    handleError() {
      this.error = null;
    },
    homeurl(){
      if(this.isMobile)
      {
        return '/m';
      }else{
        return '/';
      }
    }
  },
};
</script>

<style lang="scss" scoped>
form {
  margin: 1rem;
  padding: 1rem;
  padding-top:0;
}
.logo-field{
    text-align:center;
    padding:20px 0;
}
.login-title{
    font-weight:bold;
    padding-left:2rem;
    font-size:16px;
    font-family:malgungothic;
}
fieldset{
  border: 0;
  legend{display:none;}
  font-family:굴림,gulim;
  .login_set{
    .input_list{

        input{
            padding:0 20px;
            height:49px;
            border: 1px solid #dadada;
            font-size: 12px;
            width:100%;
        }
        .dd_mb_pw input{
            border-top:1px solid #fff !important;
        }

    }
    .forKakao{
      margin-top:-10px;
      background:#fee500;
      border: none;
      padding:15px;
      font-weight:bold;
      width: 100%;
      cursor: pointer;
      display: flex;
      justify-content: center;
      .icon{
        padding-right:30px;
      }
    }
  }

  .acc{
      margin:20px 0;
      display:flex;
      justify-content: space-between;
      font-size:12px;
      color: #999;
      ul{
          display:flex;

          li{
              a{
                  line-height: 19px;
                  color: #999;
              }
              .bar{
                margin: 4px 10px 0;
                width: 1px;
                height: 11px;
                background-color: #e5e5e5;
                display: inline-block;
              }
          }
      }
  }
  .alert-valid{
      font-size:12px;
      color:#b72e00;
  }
}
.footer{
    font-size: 10px;
    font-family: Arial,Helvetica,sans-serif;
    text-align: center;
    color: #999;
}


</style>
